module.exports = __webpack_public_path__ + "img/header-memoireRingsColored@2x.258088e.jpg";